import { Link } from 'react-router-dom';
import { Camera, Sparkles, CheckCircle2, ArrowRight } from 'lucide-react';
import { getUser } from '../lib/api';

export function LandingPage() {
  const user = getUser();
  const ctaTo = user ? (user.role === 'admin' ? '/admin' : '/app') : '/login';
  const ctaLabel = user ? '进入工作台' : '立即使用';

  return (
    <div className="min-h-dvh bg-gradient-to-b from-sky-50 via-white to-white text-slate-900">
      <header className="mx-auto flex h-14 max-w-5xl items-center px-4">
        <Link to="/" className="flex items-center gap-2 font-semibold text-sky-700">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-sky-600 text-sm text-white shadow-sm">
            算
          </span>
          <span className="text-base">珠心算识别</span>
        </Link>
        <div className="flex-1" />
        {user ? (
          <Link
            to={ctaTo}
            className="inline-flex h-9 items-center gap-1 rounded-md bg-sky-600 px-3 text-sm font-medium text-white hover:bg-sky-700"
          >
            {ctaLabel}
            <ArrowRight className="h-4 w-4" />
          </Link>
        ) : (
          <Link
            to="/login"
            className="inline-flex h-9 items-center rounded-md px-3 text-sm font-medium text-slate-600 hover:bg-slate-100"
          >
            登录
          </Link>
        )}
      </header>

      <section className="mx-auto max-w-5xl px-4 pb-10 pt-10 sm:pt-16">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1 rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700">
            <Sparkles className="h-3.5 w-3.5" />
            AI 辅助 · 专为家长老师设计
          </span>
          <h1 className="mt-4 text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl">
            拍一张照,自动帮孩子批改珠心算
          </h1>
          <p className="mt-4 text-base text-slate-600 sm:text-lg">
            上传练习题照片,几十秒后就能看到每道题的对错和正确答案。省下逐题核对的时间,专注陪孩子讲错题。
          </p>
          <div className="mt-6 flex items-center justify-center gap-3">
            <Link
              to={ctaTo}
              className="inline-flex h-11 items-center gap-1 rounded-lg bg-sky-600 px-5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-sky-700"
            >
              {ctaLabel}
              <ArrowRight className="h-4 w-4" />
            </Link>
            {!user && (
              <a
                href="#how"
                className="inline-flex h-11 items-center rounded-lg border border-slate-200 bg-white px-5 text-sm font-medium text-slate-700 hover:bg-slate-50"
              >
                了解使用方式
              </a>
            )}
          </div>
          <p className="mt-3 text-xs text-slate-400">目前仅内测,账号由管理员统一发放</p>
        </div>
      </section>

      <section id="how" className="mx-auto max-w-5xl px-4 py-10">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            {
              icon: Camera,
              title: '1. 拍照上传',
              body: '手机随手拍练习册,最多 5 张,自动压缩不丢画质。',
            },
            {
              icon: Sparkles,
              title: '2. AI 自动识别',
              body: '视觉大模型识别题目与孩子的答案,30~120 秒出结果。',
            },
            {
              icon: CheckCircle2,
              title: '3. 一眼看错题',
              body: '正确 / 错误 / 存疑 三色标记,可筛选错题、打印留档。',
            },
          ].map((f, i) => (
            <div
              key={i}
              className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm"
            >
              <f.icon className="h-6 w-6 text-sky-600" />
              <h3 className="mt-3 text-base font-semibold text-slate-900">{f.title}</h3>
              <p className="mt-1 text-sm text-slate-600">{f.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 pb-12">
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <h2 className="text-lg font-semibold text-slate-900">适合谁用?</h2>
          <ul className="mt-3 space-y-2 text-sm text-slate-600">
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-500" />
              每天要辅导孩子作业、反复核对答案的家长
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-500" />
              需要快速批改整本练习册的珠心算老师
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-500" />
              想把错题导出打印,作为复习资料的家庭
            </li>
          </ul>
        </div>
      </section>

      <footer className="mx-auto max-w-5xl px-4 py-8 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} 珠心算识别 · 内测版
      </footer>
    </div>
  );
}
